import { e } from "./index865.mjs";
var r = e, n = /web0s(?!.*chrome)/i.test(r);
export {
  n as e
};
